import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to (0, 0) whenever the URL pathname changes.
 *
 * Render once near the top of a route subtree (or inside a feature layout
 * that wraps every top-level page in that feature) — it returns null and
 * has no DOM output of its own.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
